import { mainCategoryOnlyRouteGuard } from 'framework/router/route-helpers';

const MAP_APP_RECORD_NAMES = Object.freeze({
    SUB_CATEGORY_ENTRY: 'SUB_CATEGORY_ENTRY',
    MAIN_CATEGORY_ENTRY: 'MAIN_CATEGORY_ENTRY',
    MAIN_CATEGORY_ONLY: 'MAIN_CATEGORY_ONLY',
    ENTRY_ONLY: 'ENTRY_ONLY',
    HOME: 'HOME',
    MAP: 'MAP',
});

const MAP_APP_RECORDS = {
    'map-app': {
        routes: [
            {
                component: 'map-app',
                name: MAP_APP_RECORD_NAMES.HOME,
                path: '/',
            },
            {
                component: 'map-app',
                name: MAP_APP_RECORD_NAMES.MAP,
                path: '/karte/',
            },
            {
                component: 'map-app',
                name: MAP_APP_RECORD_NAMES.SUB_CATEGORY_ENTRY,
                path: '/karte/:maincategory/:subcategory/:entry/',
            },
            {
                component: 'map-app',
                name: MAP_APP_RECORD_NAMES.MAIN_CATEGORY_ENTRY,
                path: '/karte/:maincategory/:entry/',
            },
            {
                component: 'map-app',
                name: MAP_APP_RECORD_NAMES.MAIN_CATEGORY_ONLY,
                path: '/karte/:maincategory/',
                beforeEnter: mainCategoryOnlyRouteGuard,
            },
            {
                component: 'map-app',
                name: MAP_APP_RECORD_NAMES.ENTRY_ONLY,
                path: '/karte/:entry/',
            },
        ],
    },
};

export {
    mainCategoryOnlyRouteGuard,
    MAP_APP_RECORD_NAMES,
    MAP_APP_RECORDS as default,
};
